// pretty primitive type guard for AdaptableObject, but currently there is no better/safer way
export const isAdaptableObject = (object) => {
    return object != undefined && typeof object['Uuid'] === 'string';
};
